export default __webpack_public_path__ + "static/media/ChartCard.f4ffcf1c.less";